import * as React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { Grid } from "@mui/material";

export default function StandardSkeletoon({ row = 4, col = 1, show = true, height=30 }) {
  return (
    <Grid display={show ? "flex" : "none"} >
      {Array.from({ length: col }).map((_, idx) => (
        <Box display={show ? "block" : "none"} m={0.5} width={"100%"}>
          {Array.from({ length: row }).map((_, idx) => (
            <Skeleton key={idx} animation="pulse" height={height} />
          ))}
        </Box>
      ))}
    </Grid>
  );
}
